import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 15 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" id=\"trash\">\n  <path fill-rule=\"evenodd\" d=\"M385.76,122.036a1.01,1.01,0,0,0,1.012.964h9.455a1.01,1.01,0,0,0,1.012-.964l0.676-14.166h-12.83Zm7.879-10.647a0.41,0.41,0,0,1,.411-0.409h0.658a0.41,0.41,0,0,1,.411.409v8.093a0.41,0.41,0,0,1-.411.408H394.05a0.41,0.41,0,0,1-.411-0.408v-8.093Zm-2.879,0a0.41,0.41,0,0,1,.411-0.409h0.658a0.41,0.41,0,0,1,.411.409v8.093a0.41,0.41,0,0,1-.411.408h-0.658a0.41,0.41,0,0,1-.411-0.408v-8.093Zm-2.88,0a0.41,0.41,0,0,1,.412-0.409h0.658a0.41,0.41,0,0,1,.411.409v8.093a0.41,0.41,0,0,1-.411.408h-0.658a0.411,0.411,0,0,1-.412-0.408v-8.093Zm0,0,10.484-7.359H394v-0.819A0.211,0.211,0,0,0,393.79,103h-4.58a0.211,0.211,0,0,0-.213.211v0.819h-4.362a0.634,0.634,0,0,0-.635.632v1.984h15v-1.984a0.634,0.634,0,0,0-.636-0.632h0Zm0,0\" transform=\"translate(-384 -103)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash.svg
// module id = null
// module chunks = 